import React, { useState } from "react";
import PasswordInput from "./PasswordInput";
import { BASE } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { PRIVACY_EMAIL } from '../services/privacy';

const API_BASE = `${BASE}/auth`;

export default function RecuperarSenha() {
  const { isLogado, isAdministrador } = useAuth();
  const [idCorretor, setIdCorretor] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleRecuperarSenha(e) {
    e.preventDefault();
    setMensagem("");
    setErro("");

    if (!idCorretor) {
      setErro("Preencha o ID do corretor.");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_BASE}/recuperar-senha`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id_corretor: idCorretor }),
      });

      const data = await response.json();

      if (!response.ok) {
        setErro(data.error || "Erro ao recuperar senha.");
        return;
      }

      setMensagem(data.ok || data.message || "Senha alterada com sucesso.");
      setIdCorretor("");
      setNovaSenha(data.senha_temporaria || '');
    } catch {
      setErro("Não foi possível conectar ao servidor.");
    } finally {
      setLoading(false);
    }
  }

  if (!isLogado || !isAdministrador) {
    return <div className="ds-auth-wrapper"><div className="ds-auth-card">
      <h2>Recuperar acesso</h2>
      <p>Solicite a recuperação à administração da 61 Imóveis. A equipe deverá confirmar sua identidade antes de redefinir o acesso.</p>
      <a href={`mailto:${PRIVACY_EMAIL}?subject=Recuperar%20acesso`}>{PRIVACY_EMAIL}</a>
      <p>Não envie sua senha por e-mail.</p>
    </div></div>;
  }

  return (
    <div className="ds-auth-wrapper">
      <div className="ds-auth-card">
        <span className="ds-auth-accent" />
        <h2 className="ds-auth-title">Recuperar Senha</h2>
        <p className="ds-auth-subtitle">Confirme a identidade do corretor e gere uma senha temporária. As sessões anteriores serão encerradas e ele deverá criar uma nova senha ao entrar.</p>

        <form className="ds-form" onSubmit={handleRecuperarSenha}>
          <div className="ds-form-group">
            <label className="ds-label" htmlFor="id-corretor">ID do Corretor</label>
            <input id="id-corretor" className="ds-input" type="text"
              value={idCorretor} onChange={(e) => { setIdCorretor(e.target.value); setNovaSenha(''); setMensagem(''); }}
              placeholder="Digite o ID do corretor" disabled={loading} />
          </div>

          {novaSenha && <div className="ds-form-group">
            <label className="ds-label" htmlFor="nova-senha-rec">Senha temporária gerada</label>
            <PasswordInput id="nova-senha-rec"
              value={novaSenha} readOnly autoComplete="off" />
            <small>Entregue ao corretor pelo canal combinado. Ela não será exibida novamente após sair desta tela.</small>
          </div>}

          {erro     && <div className="ds-alert ds-alert-error">{erro}</div>}
          {mensagem && <div className="ds-alert ds-alert-success">{mensagem}</div>}

          <button type="submit" className="ds-btn ds-btn-primary ds-btn-full" disabled={loading}>
            {loading ? <><span className="ds-spinner" /> Gerando...</> : 'Gerar senha temporária'}
          </button>
        </form>
      </div>
    </div>
  );
}
